import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { PropertySelectDialogTableComponent } from './components/property-select-dialog-table/property-select-dialog-table.component';

@Component({
  selector: 'app-property-select-dialog',
  templateUrl: './property-select-dialog.component.html',
  styleUrls: ['./property-select-dialog.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatIcon,
    MatDialogModule,
    MatButtonModule,
    PropertySelectDialogTableComponent
  ]
})
export class PropertySelectDialogComponent {

  selectedPropertyId: string = '';
  organizationId: any;

  constructor(
    private readonly dialogRef: MatDialogRef<PropertySelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.organizationId = this.data;
  }

  onPropertySelected(property: any) {
    if (property?.id != null) {
      this.dialogRef.close(property.id);
    } else {
      this.dialogRef.close();
    }
  }
}